import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Ticket Dispositions section — collapsible toggle list.
 */
import { CollapsibleSection } from '../../shared/components/CollapsibleSection';
import { ToggleList } from '../../shared/components/ToggleList';
import dispositions from '../../../backbone/lib/ticket_dispositions.json';
export function DispositionsPanel({ form }) {
    return (_jsx(CollapsibleSection, { title: "Ticket Dispositions", className: "dispositions-panel", children: _jsx(ToggleList, { items: dispositions, checked: form.dispositionCodes, onChange: form.toggleDisposition, sort: true }) }));
}
